export const domains = [
  typeof document !== 'undefined' ? `.${document.domain}` : null,
  '.sketch.com',
  'localhost',
  '127.0.0.1',
].filter(Boolean) as string[]

export const PROFILE_URL_PREFIX = `sketch.com/profile/`
